const Slot = require('../domain/slot'),
	adManager = require('./adManager'),
	breakpoints = require('../../services/breakpoints'),
	sizeMappings = require('../../services/sizeMappings'),
	slotsStates = require('../domain/slotStates'),
	pubsub = require('../../utils/pubsub'),
	querystring = require('../../utils/querystring'),
	lazyLoadService = require('../../services/lazyLoadService');

let slots = [];

_hookEvents();

function init(/** Settings */ settings) {
	_removeSlots();

	slots = Object.keys(settings.slots).map((slotName) => {
		const slotDef = Object.assign({}, settings.slots[slotName], {
			'name': slotName
		});

		return new Slot(slotDef, settings);
	});

	adManager.onSlotVisibilityChanged(_onSlotVisibilityChanged);
	adManager.onImpressionViewable(_onImpressionViewable);

	return defineSlots(slots.filter(s => s.getPreload()))
		.then(() => slots); // Return all slots after define
}

function _hookEvents() {
	pubsub.subscribe('breakpoint.changed', _onBreakpointChange);
	pubsub.subscribe('slot.rendered', _printSlotTagInfo);
	pubsub.subscribe('slot.error', _printSlotTagInfo);
}

function _removeSlots() {
	slots.forEach((slot) => {
		slot.removeNode();
	});

	slots = [];
}

function defineSlots(toDefine) {
	return Promise.all(toDefine
		.filter(_isUsedOnCurrentBreakpoint)
		.map((slot) => slot.define()));
}

function _onBreakpointChange(currentBreakpoint) {
	return Promise.all(slots
		.filter((/** Slot*/ slot) => slot.renderBreakpoint && slot.renderBreakpoint !== currentBreakpoint)
		.filter((/** Slot*/ slot) => slot.state === slotsStates.RENDERED)
		.map((slot) => slot.refresh('breakpoint_changed')));
}

function _onSlotVisibilityChanged(e) {
	slots.forEach((/** Slot */ slot) => {
		if (slot.domId === e.slot.getSlotElementId()) {
			slot.updateInViewPercentage(e.inViewPercentage);
		}
	});
}

function _onImpressionViewable(e) {
	slots.forEach((/** Slot */ slot) => {
		if (slot.domId === e.slot.getSlotElementId()) {
			slot.updateHasImpression(true);
		}
	});
}

function _printSlotTagInfo(/** Slot */ slot) {
	if (typeof querystring.get('taginfo') === 'undefined') {
		return;
	}

	const {
			name, sizeMapping, size, outOfPage, lazyLoaded, refreshable, state, isEmpty, creativeId, lineItemId, campaignId, advertiserId, refreshModes
		} = slot,
		curentSizes = sizeMappings.getSizesFromSizeMapForBreakpoint(sizeMapping, breakpoints.getCurrentBreakpoint()),
		slotProps = {
			'slot': name,
			'adUnit': slot.getAdUnit(),
			sizeMapping,
			'sizes': curentSizes && curentSizes.map((sz) => Array.isArray(sz) ? sz.join('x') : sz).join(', '),
			'size': size && size.join('x'),
			outOfPage,
			lazyLoaded,
			refreshable,
			refreshModes,
			state,
			isEmpty,
			creativeId,
			lineItemId,
			campaignId,
			advertiserId
		},
		slotTargeting = adManager.getAppliedTargeting(slot);

	console.log('%c[ADVERT]%c Taginfo:', 'color:#fff;background:#cb1e7b;border-bottom: 1px solid #fff;', '');
	console.log('-- Slot properties --');
	console.log(Object.keys(slotProps).map((field) => `${field} = ${slotProps[field]}`).join('\n'));
	console.log('-- Targeting --');
	console.log(Object.keys(slotTargeting).map((field) => `${field} = ${slotTargeting[field]}`).join('\n'));
}

function _isUsedOnCurrentBreakpoint(slot) {
	const sizes = sizeMappings.getSizesFromSizeMapForBreakpoint(slot.sizeMapping, breakpoints.getCurrentBreakpoint())

	return slot.outOfPage || typeof sizes !== 'undefined' && sizes.length > 0;
}

function getSlot(slotName) {
	return slots.find((/** Slot */ s) => s.name === slotName);
}

async function loadSlot(slotName, nodeId) {
	const slot = slots.find((/** Slot */ s) => s.name === slotName),
		slotIdentifier = nodeId || slotName;

	if (!slot) {
		throw new Error(`No slot found for ${slotName}`);
	}

	const node = document.getElementById(slotIdentifier);

	if (!node) {
		// Slot already loaded for this node
		if (slot.node && slot.node.getAttribute('data-advert-orig-id') === slotIdentifier) {
			return;
		}
		throw new Error(`No DOM element found for id ${slotIdentifier}`);
	}

	if (slot.node === node) {
		return;
	}

	if (!_isUsedOnCurrentBreakpoint(slot)) {
		return;
	}

	// Trying to load for a different DOM position
	if (slot.node && slot.node !== node) {
		await slot.reset();
		await slot.define();
	}

	await slot.load(node);

	if (slot.lazyLoaded) {
		await lazyLoadService.waitForSlot(slot);
	}

	return slot.render();
}

function getSlots() {
	return slots;
}

module.exports = {
	init,
	loadSlot,
	defineSlots,
	getSlot,
	getSlots
};
